import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const DEFAULT_GRADIENT = 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)';

const cardShellClass =
  'relative overflow-hidden rounded-2xl border bg-white shadow-sm transition-all duration-200';

const childButtonClass =
  'px-3 py-2 text-xs rounded-full border inline-flex items-center gap-2 shadow-sm transition-all duration-200';

export default function SectionIndexCards({
  title = 'Indice de secciones',
  helperText = '',
  items = [],
  columnsClassName = 'md:grid-cols-2',
  className = '',
}) {
  return (
    <div className={`bg-white rounded-2xl shadow border border-gray-200 p-4 sm:p-5 ${className}`}>
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        {helperText ? (
          <p className="mt-1 text-xs text-gray-500">{helperText}</p>
        ) : null}
      </div>

      <div className={`grid grid-cols-1 ${columnsClassName} gap-3`}>
        {items.map((item) => {
          const Icon = item.icon;
          const active = Boolean(item.active);
          const expanded = Boolean(item.expanded);
          const hasChildren = Array.isArray(item.children) && item.children.length > 0;
          const gradient = item.gradient || DEFAULT_GRADIENT;
          const accentGradient = item.accentGradient || gradient;
          const inactiveTextClass = item.inactiveTextClass || 'text-gray-700';
          const activeRingClass = item.activeRingClass || 'border-gray-200';

          return (
            <div
              key={item.key}
              className={`${cardShellClass} ${active || expanded ? `${activeRingClass} ring-1 ring-offset-0` : 'border-gray-200 hover:border-gray-300 hover:shadow-md'}`}
              style={active || expanded ? { boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)' } : undefined}
            >
              <div className="absolute left-0 top-0 bottom-0 w-1" style={{ background: accentGradient }} />

              <button
                type="button"
                onClick={item.onClick}
                className="w-full px-5 py-4 text-left"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="flex items-center gap-3 min-w-0">
                    <div
                      className="h-12 w-12 rounded-2xl flex items-center justify-center text-white shadow-sm shrink-0"
                      style={{ background: gradient }}
                    >
                      {Icon ? <Icon size={20} className="text-white" /> : null}
                    </div>
                    <div className="min-w-0">
                      <div className="text-lg font-semibold text-gray-900 truncate">{item.title}</div>
                      {item.description ? (
                        <div className="text-sm text-gray-600 mt-0.5">{item.description}</div>
                      ) : null}
                    </div>
                  </div>

                  {hasChildren ? (
                    expanded ? <ChevronDown size={18} className="text-gray-500 shrink-0" /> : <ChevronRight size={18} className="text-gray-500 shrink-0" />
                  ) : (
                    <span className={`text-xs font-semibold ${active ? 'text-gray-900' : inactiveTextClass}`}>
                      {active ? 'Activo' : 'Abrir'}
                    </span>
                  )}
                </div>
              </button>

              {hasChildren && expanded ? (
                <div className="border-t border-gray-100 px-4 pb-4">
                  <div className="pt-4 flex flex-wrap gap-2">
                    {item.children.map((child) => (
                      <button
                        key={child.key}
                        type="button"
                        onClick={child.onClick}
                        className={`${childButtonClass} ${child.active ? 'text-white border-transparent' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-50'}`}
                        style={child.active ? { background: child.gradient || gradient } : undefined}
                      >
                        {child.icon ? <child.icon size={14} className={child.active ? 'text-white' : 'text-gray-500'} /> : null}
                        <span>{child.label}</span>
                      </button>
                    ))}
                  </div>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
